import * as api from "./client";

export type GatewayRouteEntry = {
  id: string;
  serviceName: string;
  method: string;
  path: string;
  enabled: boolean;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
  stale: boolean;
};

export const gatewayRoutesService = {
  async getAll(): Promise<{ routes: GatewayRouteEntry[]; requestId: string }> {
    return api.get("/v1/platform/gateway-routes");
  },

  async create(body: {
    serviceName: string;
    method: string;
    path: string;
  }): Promise<{ route: GatewayRouteEntry; requestId: string }> {
    return api.post("/v1/platform/gateway-routes", body);
  },

  async setEnabled(id: string, enabled: boolean): Promise<void> {
    return api.patch(`/v1/platform/gateway-routes/${id}`, { enabled });
  },

  async remove(id: string): Promise<void> {
    return api.del(`/v1/platform/gateway-routes/${id}`);
  },
};
